<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M12.9 6.74998C12.9 6.25292 12.4971 5.84998 12 5.84998C11.5029 5.84998 11.1 6.25292 11.1 6.74998V12C11.1 12.2282 11.1867 12.4479 11.3425 12.6146L14.8333 16.3488C15.1727 16.7119 15.7422 16.7311 16.1053 16.3917C16.4684 16.0523 16.4876 15.4827 16.1482 15.1196L12.9 11.6448V6.74998Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2.09998C6.53239 2.09998 2.10001 6.53236 2.10001 12C2.10001 17.4676 6.53239 21.9 12 21.9C17.4676 21.9 21.9 17.4676 21.9 12C21.9 6.53236 17.4676 2.09998 12 2.09998ZM3.90001 12C3.90001 7.52647 7.5265 3.89998 12 3.89998C16.4735 3.89998 20.1 7.52647 20.1 12C20.1 16.4735 16.4735 20.1 12 20.1C7.5265 20.1 3.90001 16.4735 3.90001 12Z"
    />
  </svg>
</template>
